export default __webpack_public_path__ + "static/media/custom-checklist.f5b72393.svg";